import {
  Card,
  CardBody,
  CardHeader,
  Flex,
  Heading,
  Progress,
  Skeleton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import type { AgentPerformanceItem } from '@/lib/services/helpdeskDashboardService'

type Props = {
  agents: AgentPerformanceItem[]
  loading?: boolean
  limit?: number
}

export default function AgentPerformanceCard({ agents, loading, limit = 3 }: Props) {
  const rows = agents.slice(0, limit)

  return (
    <Card bg="white" borderRadius="md" boxShadow="sm">
      <CardHeader pb={2}>
        <Flex justify="space-between" align="center" gap={3} flexWrap="wrap">
          <Heading size="md">Agent performance (top {limit})</Heading>
          <Text
            as={RouterLink}
            to="/reports/agent-performance"
            fontSize="sm"
            color="blue.600"
            _hover={{ textDecoration: 'underline' }}
          >
            View full report ↗
          </Text>
        </Flex>
      </CardHeader>
      <CardBody pt={0} overflowX="auto">
        {loading ? (
          <Skeleton height="120px" width="100%" />
        ) : (
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Agent</Th>
                <Th>Open</Th>
                <Th>Avg FRT</Th>
                <Th>Load</Th>
              </Tr>
            </Thead>
            <Tbody>
              {rows.length === 0 ? (
                <Tr>
                  <Td colSpan={4} textAlign="center" color="gray.500" py={4}>
                    No agent data
                  </Td>
                </Tr>
              ) : (
                rows.map((agent) => (
                  <Tr key={agent.agent_id}>
                    <Td>{agent.name}</Td>
                    <Td>{agent.open_ticket}</Td>
                    <Td>
                      {agent.avg_frt_seconds >= 60
                        ? `${Math.floor(agent.avg_frt_seconds / 60)}m`
                        : `${agent.avg_frt_seconds}s`}
                    </Td>
                    <Td>
                      <Progress
                        value={agent.load_percent}
                        size="sm"
                        colorScheme="blue"
                        borderRadius="full"
                        w="80px"
                      />
                    </Td>
                  </Tr>
                ))
              )}
            </Tbody>
          </Table>
        )}
      </CardBody>
    </Card>
  )
}
